import { BaseCarouselProps, Container, WithGradientedName } from '@/components';
import { Box, Typography } from '@mui/material';
import { FC, ReactElement } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import styles from './styles.module.scss';
import SlideImage1 from '/public/images/about/weAreImg2.jpg';
import SlideImage2 from '/public/images/about/weAreImg3.jpg';
import SlideImage3 from '/public/images/about/weAreImg4.jpg';
import Image, { StaticImageData } from 'next/image';
import dynamic from 'next/dynamic';

const BaseCarousel = dynamic<BaseCarouselProps<CarouselItem>>(
  () => import('@/components').then((module) => module.BaseCarousel),
  {
    ssr: false,
  },
);

type CarouselItem = {
  id: string;
  image: StaticImageData;
};

const CAROUSEL_ITEMS = [
  {
    id: 'item-0',
    image: SlideImage1,
  },
  {
    id: 'item-1',
    image: SlideImage2,
  },
  {
    id: 'item-2',
    image: SlideImage3,
  },
];

export const WeArePowerleadSection: FC = () => {
  const { t } = useTranslation('about');

  return (
    <Box component="section" className={styles.section}>
      <Container>
        <Typography variant="h2" className={styles.title}>
          <WithGradientedName text={t('weArePowerlead.title')} />
        </Typography>
        <Typography variant="subtitle1" className={styles.text}>
          <Trans ns="about" i18nKey="weArePowerlead.text" />
        </Typography>
        <BaseCarousel
          items={CAROUSEL_ITEMS}
          renderSlide={(item): ReactElement => {
            return (
              <Box className={styles.carouselItem}>
                <Image src={item.image} alt="" />
              </Box>
            );
          }}
        />
      </Container>
    </Box>
  );
};
